import { getDateDiffFromNow } from '../../../utils/dates';
import { BarChartDataItem } from '@silverfort/sf-components';

const ONE_MINUTE = 1;
const FULL_HOUR_IN_MINUTES = 60;
const FULL_DAY_IN_HOURS = 24;

export const getLastSyncTooltipText = (lastSync: Date | null | undefined): string => {
    if (!lastSync) return 'Last sync time unavailable';

    const diffMinutes = getDateDiffFromNow(lastSync, 'minutes');
    const diffHours = getDateDiffFromNow(lastSync, 'hours');
    const diffDays = getDateDiffFromNow(lastSync, 'days');

    if (diffMinutes < ONE_MINUTE) return 'Last successful sync a minute ago';
    if (diffMinutes < FULL_HOUR_IN_MINUTES) return `Last successful sync ${diffMinutes} minutes ago`;
    if (diffHours < FULL_DAY_IN_HOURS) return `Last successful sync ${diffHours} hours ago`;
    return `Last successful sync ${diffDays} days ago`;
};

export const formatAuthTrafficShortDates = (dateStr: string, index: number, data: BarChartDataItem[]): string => {
    if (index === 0) {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    try {
        const currentDate = new Date(dateStr);
        const previousDate = new Date(data[index - 1].date);

        const monthChanged =
            currentDate.getMonth() !== previousDate.getMonth() ||
            currentDate.getFullYear() !== previousDate.getFullYear();

        if (monthChanged) {
            return currentDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        } else {
            return currentDate.getDate().toString();
        }
    } catch {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
};
